{
 "_": "도구 UI 의 버튼 이름과 설명. 사람이 부르는 이름이 여기 있다. node scripts/dsl/build-labels.mjs 로 다시 뽑는다.",
 "source": "/root/dev/git.cemware.com/mathcore/module/mathcore/lib/base2d-ui/src/tab/tools/configs/base2d-geometry.ts · /root/dev/git.cemware.com/mathcore/module/math3d-ui/src/app/components/tabs/geometry/config.ts",
 "labels": {
  "point.basic": {
   "ko": "점",
   "group": "점",
   "explain": "점을 만들 위치를 선택하세요."
  },
  "point.middlePointBySegment": {
   "ko": "중점",
   "group": "점",
   "explain": "선분 또는 두 점을 선택하세요."
  },
  "point.pointOnObject": {
   "ko": "대상 위의 점",
   "group": "점",
   "explain": "선 또는 다각형을 선택하세요."
  },
  "point.intersect": {
   "ko": "교점",
   "group": "점",
   "explain": "교차하는 선의 교차점을 선택하거나, 두 선을 연속적으로 선택하세요."
  },
  "point.lineTracing": {
   "ko": "라인 트레이싱",
   "group": "점",
   "explain": "대수 그래프를 선택하세요."
  },
  "linear.segment": {
   "ko": "선분",
   "group": "선",
   "explain": "두 점을 선택하세요."
  },
  "linear.segmentOfGivenLength": {
   "ko": "주어진 길이의 선분",
   "group": "선",
   "explain": "한 점을 선택 후 선분의 길이를 입력하세요."
  },
  "linear.line": {
   "ko": "직선",
   "group": "선",
   "explain": "두 점을 선택하세요."
  },
  "linear.ray": {
   "ko": "반직선",
   "group": "선",
   "explain": "두 점을 선택하세요."
  },
  "linear.parallel": {
   "ko": "평행선",
   "group": "선",
   "explain": "평행이 될 선을 선택하고 만들 위치를 선택하거나, 만들 위치를 선택하고 평행이 될 선을 선택하세요."
  },
  "linear.perpendicular": {
   "ko": "수선",
   "group": "선",
   "explain": "수직이 될 선을 선택하고 만들 위치를 선택하거나, 만들 위치를 선택하고 수직이 될 선을 선택하세요."
  },
  "linear.perpendicularBisectorBySegment": {
   "ko": "수직이등분선",
   "group": "선",
   "explain": "두 점 또는 한 선분을 선택하세요."
  },
  "linear.bisectorLine": {
   "ko": "각의 이등분선",
   "group": "선",
   "explain": "세 점을 선택하세요."
  },
  "linear.tangentLine": {
   "ko": "접선",
   "group": "선",
   "explain": "접선을 생성할 곡선(원, 타원, 대수 그래프)을 선택하고 접선이 지나는 점 또는 접선의 기울기가 될 선을 선택하세요."
  },
  "linear.trendLine": {
   "ko": "추세선",
   "group": "선",
   "explain": "마우스를 드래그하여 선택한 점으로 추세선을 생성합니다."
  },
  "linear.vector": {
   "ko": "벡터",
   "group": "선",
   "explain": "시작점을 선택한 후 끝점을 선택하세요."
  },
  "linear.vectorFromPoint": {
   "ko": "시작점과 벡터",
   "group": "선",
   "explain": "점과 벡터를 선택합니다."
  },
  "circle.circleWithCenter": {
   "ko": "원 : 중심과 한 점",
   "group": "원과 곡선",
   "explain": "중심을 선택한 후 원이 그려질 한 점을 선택하세요."
  },
  "circle.circleWithCenterAndRadius": {
   "ko": "원 : 중심과 반지름",
   "group": "원과 곡선",
   "explain": "중심을 선택한 후 반지름을 입력하세요."
  },
  "circle.circleThroughThreePoints": {
   "ko": "원 : 세 점",
   "group": "원과 곡선",
   "explain": "원이 그려질 세 점을 선택하세요."
  },
  "circle.compassWithCircle": {
   "ko": "원 : 컴퍼스",
   "group": "원과 곡선",
   "explain": "반지름이 될 선분 또는 원 또는 두 점을 선택한 후, 새로운 원을 만들 위치를 선택하세요."
  },
  "circle.arc": {
   "ko": "호",
   "group": "원과 곡선",
   "explain": "중심과 두 점을 선택하세요."
  },
  "circle.arcThroughThreePoints": {
   "ko": "호(외접원)",
   "group": "원과 곡선",
   "explain": "호가 그려질 세 점을 선택하세요."
  },
  "circle.fan": {
   "ko": "부채꼴",
   "group": "원과 곡선",
   "explain": "중심과 두 점을 선택하세요."
  },
  "circle.segmentOfCircle": {
   "ko": "활꼴",
   "group": "원과 곡선",
   "explain": "중심과 두 점을 선택하세요."
  },
  "polygon.polygon": {
   "ko": "다각형·고정된 다각형",
   "group": "다각형",
   "explain": "모든 꼭짓점을 선택하고 처음 꼭짓점을 다시 선택하세요."
  },
  "polygon.regularWithCenterAndVertex": {
   "ko": "정다각형 : 중심과 한 점",
   "group": "다각형",
   "explain": "중심과 한 점을 선택한 후 꼭짓점 수를 입력하세요."
  },
  "polygon.regularWithOneSide": {
   "ko": "정다각형 : 한 변",
   "group": "다각형",
   "explain": "한 변이 될 두 점을 선택한 후 꼭짓점 수를 입력하세요."
  },
  "polygon.isoscelesTriangle": {
   "ko": "이등변삼각형·주어진 크기의 각",
   "group": "다각형",
   "explain": "이등변삼각형이 그려질 세 점을 선택하세요."
  },
  "polygon.rightTriangle": {
   "ko": "직각삼각형",
   "group": "다각형",
   "explain": "직각삼각형이 그려질 세 점을 선택하세요."
  },
  "polygon.rectangle": {
   "ko": "직사각형",
   "group": "다각형",
   "explain": "직사각형이 그려질 세 점을 선택하세요."
  },
  "polygon.parallelogram": {
   "ko": "평행사변형",
   "group": "다각형",
   "explain": "평행사변형이 그려질 세 점을 선택하세요."
  },
  "polygon.rhombus": {
   "ko": "마름모",
   "group": "다각형",
   "explain": "마름모가 그려질 세 점을 선택하세요."
  },
  "polygon.trapezoid": {
   "ko": "사다리꼴",
   "group": "다각형",
   "explain": "사다리꼴이 그려질 네 점을 선택하세요."
  },
  "measure.lengthByObjectId": {
   "ko": "길이",
   "group": "측정과 변환",
   "explain": "길이를 측정할 두 점 또는 선분을 선택하세요."
  },
  "measure.angle": {
   "ko": "각도",
   "group": "측정과 변환",
   "explain": "각도를 측정할 세 점을 선택하세요."
  },
  "measure.area": {
   "ko": "넓이",
   "group": "측정과 변환",
   "explain": "넓이를 측정할 다각형 또는 원을 선택하세요."
  },
  "measure.gradient": {
   "ko": "기울기",
   "group": "측정과 변환",
   "explain": "두 점 또는 선을 선택하세요."
  },
  "transform.rotation": {
   "ko": "회전이동",
   "group": "측정과 변환",
   "explain": "회전시킬 대상을 선택한 후 기준점을 선택하여 회전할 각도를 입력하세요."
  },
  "transform.translation": {
   "ko": "평행이동",
   "group": "측정과 변환",
   "explain": "평행이동시킬 대상을 선택한 후 평행이동할 좌표를 입력하세요."
  },
  "transform.pointSymmetry": {
   "ko": "점대칭",
   "group": "측정과 변환",
   "explain": "대칭시킬 대상을 선택한 후 기준점을 선택하세요."
  },
  "transform.lineSymmetry": {
   "ko": "선대칭",
   "group": "측정과 변환",
   "explain": "대칭시킬 대상을 선택한 후 기준선을 선택하세요."
  },
  "transform.scale": {
   "ko": "점을 중심으로 확대",
   "group": "측정과 변환",
   "explain": "확대시킬 대상을 선택한 후 점을 선택하여 확대시킬 배율을 입력하세요."
  },
  "deco.annotationByTwoPoints": {
   "ko": "설명선",
   "group": "꾸미기",
   "explain": "설명선을 만들 선분 또는 두점을 선택한 후 위치를 선택하세요."
  },
  "deco.direction": {
   "ko": "평행",
   "group": "꾸미기",
   "explain": "평행을 만들 선을 선택하세요."
  },
  "deco.lengthByObject": {
   "ko": "길이",
   "group": "꾸미기",
   "explain": "길이를 만들 선을 선택하세요."
  },
  "deco.angle": {
   "ko": "각도",
   "group": "꾸미기",
   "explain": "각도를 만들 세 점을 선택하세요."
  },
  "etc.bezierCurve": {
   "ko": "베지어 곡선",
   "group": "꾸미기",
   "explain": "두 점을 선택하여 베지어 곡선을 그려보세요."
  },
  "etc.inequation": {
   "ko": "부등식",
   "group": "꾸미기",
   "explain": "두 점을 선택하여 부등식을 표현해보세요."
  },
  "etc.drawing": {
   "ko": "자유곡선",
   "group": "꾸미기",
   "explain": "마우스를 드래그하여 쓰거나 그려보세요."
  },
  "motion.motionPlay": {
   "ko": "실행",
   "group": "모션",
   "explain": "모션 실행 버튼을 만드세요."
  },
  "motion.bezierCurveMotion": {
   "ko": "베지어 경로",
   "group": "모션",
   "explain": "경로를 그리고 이동할 객체를 선택하세요."
  },
  "motion.segmentMotion": {
   "ko": "선분 경로",
   "group": "모션",
   "explain": "경로를 그리고 이동할 객체를 선택하세요."
  },
  "motion.circleMotion": {
   "ko": "원 경로",
   "group": "모션",
   "explain": "경로를 그리고 이동할 객체를 선택하세요."
  },
  "motion.arcMotion": {
   "ko": "호 경로",
   "group": "모션",
   "explain": "경로를 그리고 이동할 객체를 선택하세요."
  },
  "motion.ellipseMotion": {
   "ko": "타원 경로",
   "group": "모션",
   "explain": "경로를 그리고 이동할 객체를 선택하세요."
  },
  "motion.rotateMotion": {
   "ko": "점을 중심으로 하는 회전 경로",
   "group": "모션",
   "explain": "회전 각도를 설정하고 회전할 객체를 선택하세요."
  },
  "object.deleteObject": {
   "ko": "삭제",
   "group": "기본도구",
   "explain": "삭제할 대상을 선택하세요."
  },
  "object.addSlider": {
   "ko": "슬라이더",
   "group": "기본도구",
   "explain": "슬라이더를 만들 위치를 선택하세요."
  },
  "object.addCheckbox": {
   "ko": "체크박스",
   "group": "기본도구",
   "explain": "체크박스를 만들 위치를 선택하세요."
  },
  "object.addText3D": {
   "ko": "텍스트",
   "group": "기본도구",
   "explain": "텍스트를 만들 위치를 선택하세요."
  },
  "object.addImage": {
   "ko": "이미지",
   "group": "기본도구",
   "explain": "이미지를 만들 위치를 선택하세요."
  },
  "object.setLabelVisible": {
   "ko": "라벨 숨기기/보이기",
   "group": "기본도구",
   "explain": "라벨을 숨길 대상을 선택하세요."
  },
  "object.addPoint": {
   "ko": "점",
   "group": "점",
   "explain": "점을 만들 위치를 선택하세요."
  },
  "object.addMiddlePointFromSegment": {
   "ko": "중점",
   "group": "점",
   "explain": "선분 또는 두 점을 선택하세요."
  },
  "object.addPointOnObject": {
   "ko": "대상 위의 점",
   "group": "점",
   "explain": "선 또는 다각형을 선택하세요."
  },
  "object.addPointIntersection": {
   "ko": "교점",
   "group": "점",
   "explain": "교차하는 선의 교차점을 선택하거나, 두 선을 연속적으로 선택하세요."
  },
  "object.addSegment": {
   "ko": "선분",
   "group": "선",
   "explain": "두 점을 선택하세요."
  },
  "object.addLine": {
   "ko": "직선",
   "group": "선",
   "explain": "두 점을 선택하세요."
  },
  "object.addRay": {
   "ko": "반직선",
   "group": "선",
   "explain": "두 점을 선택하세요."
  },
  "object.addParallelLine": {
   "ko": "평행선",
   "group": "선",
   "explain": "평행이 될 선을 선택하고 만들 위치를 선택하거나, 만들 위치를 선택하고 평행이 될 선을 선택하세요."
  },
  "object.addPerpendicularLine": {
   "ko": "수직선",
   "group": "선",
   "explain": "수직이 될 선을 선택하고 만들 위치를 선택하거나, 만들 위치를 선택하고 수직이 될 선을 선택하세요."
  },
  "object.addAngleBisectorLine": {
   "ko": "각의 이등분선",
   "group": "선",
   "explain": "세 점을 선택하세요."
  },
  "object.addTangentLine": {
   "ko": "접선",
   "group": "선",
   "explain": "접선을 생성할 원을 선택하고 접선이 지나는 점 또는 접선의 기울기가 될 선을 선택하세요."
  },
  "object.addVector": {
   "ko": "벡터",
   "group": "선",
   "explain": "시작점을 선택한 후 끝점을 선택하세요."
  },
  "object.addPolygon": {
   "ko": "다각형",
   "group": "면",
   "explain": "모든 꼭짓점을 선택하고 처음 꼭짓점을 다시 선택하세요."
  },
  "object.addRegularPolygon": {
   "ko": "정다각형",
   "group": "면",
   "explain": "평면을 선택하고 정다각형이 그려질 위치를 선택하세요."
  },
  "object.addPlaneFromThreePoints": {
   "ko": "평면: 세 점",
   "group": "면",
   "explain": "세 점을 선택하세요."
  },
  "object.addParallelPlane": {
   "ko": "평행한 평면",
   "group": "면",
   "explain": "평면을 선택하고 평행한 평면이 그려질 한 점을 선택하세요."
  },
  "object.addPerpendicularPlane": {
   "ko": "수직평면",
   "group": "면",
   "explain": "수직이 될 선을 선택하고 만들 위치를 선택하거나, 만들 위치를 선택하고 수직이 될 선을 선택하세요."
  },
  "object.addCircleFromThreePoints": {
   "ko": "원: 세 점",
   "group": "면",
   "explain": "세 점을 선택하세요."
  },
  "object.addCircleFromPointAndAxis": {
   "ko": "원: 점과 축",
   "group": "면",
   "explain": "점과 축을 선택하세요."
  },
  "object.addPyramidFromPoints": {
   "ko": "각뿔",
   "group": "다면체",
   "explain": "밑면의 다각형을 선택하거나, 점을 선택하여 밑면을 만든 후, 꼭짓점을 선택하세요."
  },
  "object.addPrismFromPoints": {
   "ko": "각기둥",
   "group": "다면체",
   "explain": "밑면의 다각형을 선택하거나, 점을 선택하여 밑면을 만든 후, 윗면의 점을 선택하세요."
  },
  "object.addRegularTetrahedronFromPoints": {
   "ko": "정사면체",
   "group": "다면체",
   "explain": "평면을 선택하고 정사면체가 그려질 위치를 선택하세요."
  },
  "object.addRegularCubeFromPoints": {
   "ko": "정육면체",
   "group": "다면체",
   "explain": "평면을 선택하고 정육면체가 그려질 위치를 선택하세요."
  },
  "object.addCone": {
   "ko": "원뿔",
   "group": "다면체",
   "explain": "밑면의 중심점을 선택하고 원뿔이 그려질 위치를 선택하세요."
  },
  "object.addCylinder": {
   "ko": "원기둥",
   "group": "다면체",
   "explain": "밑면의 중심점을 선택하고 원기둥이 그려질 위치를 선택하세요."
  },
  "object.addSphereFromCenterAndPoint": {
   "ko": "구: 중심과 한 점",
   "group": "구",
   "explain": "중심을 선택한 후 구가 그려질 한 점을 선택하세요."
  },
  "object.addSphereFromCenterAndRadius": {
   "ko": "구: 중심과 반지름",
   "group": "구",
   "explain": "중심을 선택한 후 반지름을 입력하세요."
  },
  "object.addMeasurement": {
   "ko": "길이·각도·넓이·부피",
   "group": "측정과 변환",
   "explain": "길이를 측정할 두 점 또는 선분을 선택하세요."
  },
  "object.addDecoCallout": {
   "ko": "설명선",
   "group": "꾸미기",
   "explain": "설명선을 만들 선분 또는 두 점을 선택한 후 만들 위치를 선택하세요."
  },
  "object.addDecoParallel": {
   "ko": "평행",
   "group": "꾸미기",
   "explain": "평행선을 만들 선분을 선택하세요."
  },
  "object.addDecoLength": {
   "ko": "길이",
   "group": "꾸미기",
   "explain": "길이를 만들 선분을 선택하세요."
  },
  "object.addDecoAngle": {
   "ko": "각도",
   "group": "꾸미기",
   "explain": "각도를 만들 세 점을 선택하세요."
  }
 }
}
